import _Promise from "babel-runtime/core-js/promise";
import _Object$keys from "babel-runtime/core-js/object/keys";
import _defineProperty from "babel-runtime/helpers/defineProperty";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _toConsumableArray from "babel-runtime/helpers/toConsumableArray";

var ZERO = "00",
    ONE = "01",
    TWO = "02",
    THREE = "03",
    FOUR = "60",
    BENEFICIARY_TYPE = "BENEFICIARY_TYPE",
    BENEFICIARY_TYPE_PRIORITY = "BENEFICIARY_TYPE_PRIORITY",
    PRD_BASIC = "groupDatas.PRODUCT_INFO_PAGE.BASE_INFO",
    BENEFICIARY = "groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE",
    BENEFICIARY1 = "groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE_1",
    BENEFICIARY0 = "groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE_0",
    BENEFICIARY2 = "groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE_2",
    BENEFICIARY3 = "groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE_3",
    BENEFICIARY4 = "groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE_4",
    BENEFICIARY_PRODUCT_ARR = [BENEFICIARY1, BENEFICIARY0, BENEFICIARY2, BENEFICIARY3, BENEFICIARY4],
    BENEFICIARY_ALL_ARR = [BENEFICIARY, BENEFICIARY1, BENEFICIARY0, BENEFICIARY2, BENEFICIARY3, BENEFICIARY4];

var requiredFields = ["ACT_CTRL_CPNY", "ACT_OTHER_FORMS", "BENEFICIARY_ADDR", "BENEFICIARY_EXP_DATE", "BENEFICIARY_ID", "BENEFICIARY_ID_TYPE", "BENEFICIARY_NAME", "BENEFICIARY_TEL", "BENEFICIARY_TYPE", "BIRTHDAY", "NATION", "SEX", "SHARE_RATIO", "SHARE_RATION_END_DATE", "SHARE_RATION_START_DATE", "SPECIAL_PERSON_FLAG"];

var BENEFICIARY_MODULES = [{
  key: "BENEFICIARY_MODULE_1",
  title: "受益所有人（信托产品-受托人(信托公司)）",
  item_title: "信托产品受托人",
  type: ONE
}, {
  key: "BENEFICIARY_MODULE_0",
  title: "受益所有人（信托产品-委托人）",
  item_title: "信托产品委托人",
  type: ZERO
}, {
  key: "BENEFICIARY_MODULE_2",
  title: "受益所有人（信托产品-受益人）",
  item_title: "信托产品受益人",
  type: TWO
}, {
  key: "BENEFICIARY_MODULE_3",
  title: "受益所有人（信托产品-监察人）",
  item_title: "信托产品监察人",
  type: THREE
}, {
  key: "BENEFICIARY_MODULE_4",
  title: "对信托行使最终有效控制的其他自然人",
  item_title: "对信托行使最终有效控制的其他自然人",
  type: FOUR
}];
export default {
  ZERO: ZERO, ONE: ONE, TWO: TWO, THREE: THREE, FOUR: FOUR,
  BENEFICIARY_ALL_ARR: BENEFICIARY_ALL_ARR,
  BENEFICIARY_PRODUCT_ARR: BENEFICIARY_PRODUCT_ARR,
  BENEFICIARY_MODULES: BENEFICIARY_MODULES,

  initializeBeneficiaryModules: function initializeBeneficiaryModules(_this) {
    BENEFICIARY_MODULES.forEach(function (moduleConfig) {
      var key = moduleConfig.key,
          title = moduleConfig.title,
          type = moduleConfig.type;

      _this.groupDatas.CONTROLER_INFO_PAGE[key] = [_.cloneDeep(_this.groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE[0])];
      _this.groupDatas.CONTROLER_INFO_PAGE[key][0].FIELDS.CREDIT_BENEFICIARY_TYPE.FIELD_CONTROL = "0";
      _this.groupDatas.CONTROLER_INFO_PAGE[key][0].FIELDS.IS_SAME_LEGAL_REP.FIELD_CONTROL = "1";
      _this.groupDatas.CONTROLER_INFO_PAGE[key][0].MODULE_TITLE = title;
      _this.groupDatas.CONTROLER_INFO_PAGE[key][0].MODULE_ID = key;
      for (var fk in _this.groupDatas.CONTROLER_INFO_PAGE[key][0]["FIELDS"]) {
        _this.groupDatas.CONTROLER_INFO_PAGE[key][0]["FIELDS"][fk].MODULE_ID = key;
      }
    });

    _this.groupDatasTpl = _.cloneDeep(_this.groupDatas);
  },

  getFilterFieldDict: function getFilterFieldDict() {
    return ["g", "h", "i", "j", "k", "l", "m", "n"];
  },

  getFilterFieldDictNoProducts: function getFilterFieldDictNoProducts(_this, proCls, moduleObj) {
    return ["g", "f"];
  },

  getFilterFieldDictProductsField: function getFilterFieldDictProductsField(_this, type, moduleObj) {
    var beneficiaryType = moduleObj.FIELDS.BENEFICIARY_TYPE;
    beneficiaryType.FIELD_DICT_FILTER = this.getFilterFieldDictProducts(_this, type, moduleObj);
    if (!beneficiaryType.FIELD_DICT_FILTER.includes(beneficiaryType.DEFAULT_VALUE)) {
      beneficiaryType.DEFAULT_VALUE = "";
      beneficiaryType.correct = false;
    }

    moduleObj.FIELDS.IS_UPLOAD_IMG.DEFAULT_VALUE = moduleObj.FIELDS.IS_UPLOAD_IMG.DEFAULT_VALUE || "0";
    var creditBeneficiaryType = moduleObj.FIELDS.CREDIT_BENEFICIARY_TYPE;
    switch (type) {
      case ZERO:
        creditBeneficiaryType.DEFAULT_VALUE = ZERO;
        creditBeneficiaryType.FIELD_DICT_FILTER = [ZERO];
        break;
      case ONE:
        creditBeneficiaryType.DEFAULT_VALUE = ONE;
        creditBeneficiaryType.FIELD_DICT_FILTER = [ONE];
        break;
      case TWO:
        creditBeneficiaryType.DEFAULT_VALUE = TWO;
        creditBeneficiaryType.FIELD_DICT_FILTER = [TWO];
        break;
      case THREE:
        creditBeneficiaryType.DEFAULT_VALUE = THREE;
        creditBeneficiaryType.FIELD_DICT_FILTER = [THREE];
        break;
      case FOUR:
        creditBeneficiaryType.DEFAULT_VALUE = FOUR;
        creditBeneficiaryType.FIELD_DICT_FILTER = [FOUR];
        break;
    }

    creditBeneficiaryType.FIELD_REQUIRED = "0";
    creditBeneficiaryType.FIELD_CONTROL = "2";
  },

  getFilterFieldDictProducts: function getFilterFieldDictProducts(_this, type, moduleObj) {
    switch (type) {
      case ZERO:
      case TWO:
        return ["g", "n"];

      case ONE:
        return ["g", "h", "i", "j", "m"];

      case THREE:
      case FOUR:
        return ["n"];
    }
  },

  getFilterBenefitListObj: function getFilterBenefitListObj(benefitList) {
    var result = {
      BENEFICIARY_MODULE: [],
      BENEFICIARY_MODULE_1: [],
      BENEFICIARY_MODULE_0: [],
      BENEFICIARY_MODULE_2: [],
      BENEFICIARY_MODULE_3: [],
      BENEFICIARY_MODULE_4: [] };

    if (!benefitList || !benefitList.length) {
      return result;
    }

    _.each(benefitList, function (item) {
      var type = item.CREDIT_BENEFICIARY_TYPE;

      var hasInvalidField = requiredFields.every(function (field) {
        var value = item[field];
        return value === undefined || value === null || value.toString().trim() === "" || value.toString().trim() === "0" || value.toString().trim() === "-1";
      });

      if (hasInvalidField) {
        item.withoutChecked = true;
      }

      switch (type) {
        case ONE:
          result.BENEFICIARY_MODULE_1.push(item);
          break;
        case ZERO:
          result.BENEFICIARY_MODULE_0.push(item);
          break;
        case TWO:
          result.BENEFICIARY_MODULE_2.push(item);
          break;
        case THREE:
          result.BENEFICIARY_MODULE_3.push(item);
          break;
        case FOUR:
          result.BENEFICIARY_MODULE_4.push(item);
          break;
        default:
          result.BENEFICIARY_MODULE.push(item);
          break;
      }
    });

    return result;
  },

  getPrdBeneficiary: function getPrdBeneficiary(_this, params, prdBeneficiaryArr, moduleName) {
    if (params.CONTROLER_INFO_PAGE && params.CONTROLER_INFO_PAGE[moduleName] && prdBeneficiaryArr && prdBeneficiaryArr.length) {
      _.each(params.CONTROLER_INFO_PAGE[moduleName], function (item, index) {
        var sourceItem = prdBeneficiaryArr[index];
        if (sourceItem && sourceItem.MODULE_WITHOUT !== undefined) {
          item.MODULE_WITHOUT = sourceItem.MODULE_WITHOUT;
          item.withoutChecked = sourceItem.withoutChecked;
          sourceItem.NOT_CHECK = item.withoutChecked ? "1" : "0";
        } else {
          item.MODULE_WITHOUT = "";
          sourceItem && (sourceItem.NOT_CHECK = "0");
        }
        if (sourceItem && sourceItem.MODULE_SAME !== undefined) {
          item.MODULE_SAME = sourceItem.MODULE_SAME;
          item.sameChecked = sourceItem.sameChecked;
        } else {
          item.MODULE_SAME = "";
        }
      });
    }
  },

  getPrdBeneficiaryList: function getPrdBeneficiaryList(_this, params, arr1, arr0, arr2, arr3, arr4) {
    var _this2 = this;

    var beneficiaryModules = [{ arr: arr0, key: "BENEFICIARY_MODULE_0" }, { arr: arr2, key: "BENEFICIARY_MODULE_2" }, { arr: arr3, key: "BENEFICIARY_MODULE_3" }, { arr: arr4, key: "BENEFICIARY_MODULE_4" }];

    beneficiaryModules.forEach(function (mod) {
      _this2.getPrdBeneficiary(_this, params, mod.arr, mod.key);
    });
  },

  getBenefitList: function getBenefitList(_this) {
    var proCls = _.get(_this, PRD_BASIC + "[0].FIELDS.PRO_CLS.DEFAULT_VALUE"),
        beneficiaryArr = this.getPageArrayResult(_.get(_this, BENEFICIARY)),
        beneficiaryArr1 = this.getPageArrayResult(_.get(_this, BENEFICIARY1)),
        beneficiaryArr0 = this.getPageArrayResult(_.get(_this, BENEFICIARY0)),
        beneficiaryArr2 = this.getPageArrayResult(_.get(_this, BENEFICIARY2)),
        beneficiaryArr3 = this.getPageArrayResult(_.get(_this, BENEFICIARY3)),
        beneficiaryArr4 = this.getPageArrayResult(_.get(_this, BENEFICIARY4)),
        mergedArray = [];

    if (this.isTrustProducts(proCls)) {
      mergedArray = [].concat(_toConsumableArray(beneficiaryArr1), _toConsumableArray(beneficiaryArr0), _toConsumableArray(beneficiaryArr2), _toConsumableArray(beneficiaryArr3), _toConsumableArray(beneficiaryArr4));
    } else {
      mergedArray = [].concat(_toConsumableArray(beneficiaryArr));
    }
    return {
      BENEFIT_LIST: mergedArray
    };
  },

  getPageArrayResult: function getPageArrayResult(modules) {
    var resultarr = [];
    for (var i = 0; i < modules.length; i++) {
      var a = {};
      var fields = modules[i].FIELDS;
      for (var field in fields) {
        _Object$assign(a, _defineProperty({}, field, _.trim(fields[field].DEFAULT_VALUE)));
      }
      resultarr.push(a);
    }
    return resultarr;
  },

  isTrustProducts: function isTrustProducts(proCls) {
    return ["12", "12a", "99d"].includes(proCls);
  },

  handlerClassBeneficiaryIdType: function handlerClassBeneficiaryIdType(_this, proCls, moduleObj) {
    var that = this;
    _this.$nextTick(function () {

      if (!proCls) {
        moduleObj = _.get(_this, BENEFICIARY + "[0]");
        proCls = _.get(_this, PRD_BASIC + "[0].FIELDS.PRO_CLS.DEFAULT_VALUE");
      }

      var prdBeneficiary = _this.$el.querySelector("." + moduleObj.MODULE_ID);

      if (that.isTrustProducts(proCls)) {
        if (prdBeneficiary) {
          var benefiTypes = prdBeneficiary.querySelectorAll("#" + BENEFICIARY_TYPE);
          benefiTypes.forEach(function (element) {
            element.classList.remove(BENEFICIARY_TYPE_PRIORITY);
          });
        }
      } else {
          if (prdBeneficiary) {
            var _benefiTypes = prdBeneficiary.querySelectorAll("#" + BENEFICIARY_TYPE);
            _benefiTypes.forEach(function (element) {
              element.classList.add(BENEFICIARY_TYPE_PRIORITY);
            });
          }
        }
    });
  },

  isLFieldDict: function isLFieldDict(fieldData) {
    return ["l"].includes(fieldData["BENEFICIARY_TYPE"].DEFAULT_VALUE);
  },

  checkBeneficiaryIdType: function checkBeneficiaryIdType(_this, field, fieldData, moduleObj, index, isAuto) {
    var fieldVal = field.DEFAULT_VALUE;
    if (!fieldVal) {
      return;
    }
    fieldData["NATION"].DEFAULT_VALUE = ["00", "0J"].includes(fieldVal) ? "CHN" : ["0b", "0i"].includes(fieldVal) ? "HKG" : ["0c", "0j"].includes(fieldVal) ? "MAC" : ["0d"].includes(fieldVal) ? "CTN" : "";

    if (["0s"].includes(fieldVal)) {
      fieldData["NATION"].FIELD_DICT_FILTER = ["HKG", "MAC", "CTN"];
    } else {
      fieldData["NATION"].FIELD_DICT_FILTER = "";
    }

    if (["00", "0J", "0b", "0c", "0d", "0i", "0j"].includes(fieldVal)) {
      fieldData["NATION"].FIELD_CONTROL = "2";
    } else {
      fieldData["NATION"].FIELD_CONTROL = "0";
      fieldData["SEX"].FIELD_CONTROL = "0";
      "1" !== isAuto && (fieldData["NATION"].DEFAULT_VALUE = "");
      "1" !== isAuto && (fieldData["SEX"].DEFAULT_VALUE = "");
      "1" !== isAuto && (fieldData["BIRTHDAY"].DEFAULT_VALUE = "");
    }
    fieldData["BIRTHDAY"].FIELD_CONTROL = "0";

    if (["01", "0b", "0c", "0d", "0s"].indexOf(fieldVal) > -1) {
      _this.$set(fieldData.BENEFICIARY_EXP_DATE, "disabledLong", true);
      if (fieldData.BENEFICIARY_EXP_DATE.DEFAULT_VALUE === "30001231") {
        _this.$set(fieldData.BENEFICIARY_EXP_DATE, "DEFAULT_VALUE", "");
      }
    } else {
      _this.$set(fieldData.BENEFICIARY_EXP_DATE, "disabledLong", false);
    }
  },

  checkBeneficiaryId: function checkBeneficiaryId(_this, field, fieldData, moduleObj, index, isAuto) {
    var idCode = fieldData["BENEFICIARY_ID"].DEFAULT_VALUE;
    var idType = fieldData["BENEFICIARY_ID_TYPE"].DEFAULT_VALUE;
    if (!idCode) {
      return;
    }

    if (idType === "0s") {
      if (idCode && idCode.startsWith("810000")) {
        fieldData["NATION"].DEFAULT_VALUE = "HKG";
        fieldData["NATION"].FIELD_CONTROL = "2";
      } else if (idCode && idCode.startsWith("820000")) {
        fieldData["NATION"].DEFAULT_VALUE = "MAC";
        fieldData["NATION"].FIELD_CONTROL = "2";
      } else if (idCode && idCode.startsWith("830000")) {
        fieldData["NATION"].DEFAULT_VALUE = "CTN";
        fieldData["NATION"].FIELD_CONTROL = "2";
      } else {
        fieldData["NATION"].DEFAULT_VALUE = "";
        fieldData["NATION"].FIELD_CONTROL = "0";
      }
    }

    if (idCode.length === 18 && (idType === "00" || idType === "0J")) {
      var codeObject = _this.$blMethod.analyzeIDCard(idCode);
      fieldData["SEX"].DEFAULT_VALUE = codeObject.sex;
      fieldData["SEX"].FIELD_CONTROL = "2";

      fieldData["BIRTHDAY"].DEFAULT_VALUE = codeObject.birthDay;
      fieldData["BIRTHDAY"].FIELD_CONTROL = "2";
    } else {
      "1" !== isAuto && (fieldData["SEX"].DEFAULT_VALUE = "");
      "1" !== isAuto && (fieldData["BIRTHDAY"].DEFAULT_VALUE = "");
      fieldData["SEX"].FIELD_CONTROL = "0";
      fieldData["BIRTHDAY"].FIELD_CONTROL = "0";
    }
  },

  checkBeneficiaryType: function checkBeneficiaryType(_this, field, fieldData, benefitModule, index, isAuto, moduleObj) {
    try {
      if ("l" === field.DEFAULT_VALUE) {
        if (benefitModule.length > 1) {
          field.DEFAULT_VALUE = "";
          field.correct = false;
          _this.$set(field, "IS_SHOW_BENEFITYPE_BUTTON", false);
          _this.alert("已添加了受益所有人，不能再次选择豁免识别");
          return;
        }
        _Object$keys(fieldData).forEach(function (key) {
          if (_.includes(["IS_SAME_LEGAL_REP"], key)) {
            return;
          }
          if (key !== "BENEFICIARY_TYPE") {
            fieldData[key].FIELD_REQUIRED = "0";
            fieldData[key].FIELD_CONTROL = "1";
            fieldData[key].DEFAULT_VALUE = "";
          }
        });

        _this.$set(field, "IS_SHOW_BENEFITYPE_BUTTON", true);

        moduleObj && (moduleObj.MODULE_ADD = "");

        moduleObj && (moduleObj.MODULE_READ = "");

        moduleObj.need_police = "0";
        _this.$nextTick(function () {
          _this.$set(moduleObj, "MODULE_CUSTOMIZE", "");
        });
        return;
      }

      _this.$set(field, "IS_SHOW_BENEFITYPE_BUTTON", "m" === field.DEFAULT_VALUE);

      var benefitType = ["g", "h"];

      var benifitMethodFlag = _.includes(["i"], field.DEFAULT_VALUE);

      _Object$keys(fieldData).forEach(function (key) {
        if (key !== "BENEFICIARY_TYPE") {
          if (_.includes(["IS_SAME_LEGAL_REP"], key)) {
            return;
          }

          if (_.includes(["CREDIT_BENEFICIARY_TYPE"], key)) {
            return;
          }

          if (_.includes(["ACT_CTRL_CPNY"], key)) {
            fieldData[key].FIELD_REQUIRED = benifitMethodFlag ? "1" : "0";
            fieldData[key].FIELD_CONTROL = benifitMethodFlag ? "0" : "1";
          } else if (_.includes(["ACT_OTHER_FORMS"], key)) {
              var methodFlag = ["2"].includes(fieldData["ACT_CTRL_CPNY"].DEFAULT_VALUE);
              fieldData[key].FIELD_REQUIRED = benifitMethodFlag && methodFlag ? "1" : "0";
              fieldData[key].FIELD_CONTROL = benifitMethodFlag && methodFlag ? "0" : "1";
            } else if (_.includes(["SHARE_RATIO"], key)) {
                var shareFlag = _.includes(benefitType, field.DEFAULT_VALUE);
                fieldData[key].FIELD_REQUIRED = shareFlag ? "1" : "0";
                fieldData[key].FIELD_CONTROL = shareFlag ? "0" : "2";
                fieldData[key].DEFAULT_VALUE = shareFlag ? fieldData[key].DEFAULT_VALUE : "";
              } else if (_.includes(["SEX", "NATION", "BIRTHDAY"], key) && fieldData[key].DEFAULT_VALUE && fieldData[key].FIELD_CONTROL === "2") {
                  fieldData[key].FIELD_CONTROL = "2";
                } else if (_.includes(["SHARE_RATION_END_DATE", "BENEFICIARY_TEL", "BENEFICIARY_ADDR"], key) || fieldData["IS_UPLOAD_IMG"].DEFAULT_VALUE === "1" && _.includes(["BENEFICIARY_ID_TYPE", "BENEFICIARY_ID", "BENEFICIARY_EXP_DATE"], key)) {
                    fieldData[key].FIELD_REQUIRED = "0";
                    fieldData[key].FIELD_CONTROL = "0";
                  } else {
                      fieldData[key].FIELD_REQUIRED = "1";
                      fieldData[key].FIELD_CONTROL = "0";
                    }
          fieldData[key].correct = true;
          fieldData[key].showerr = false;
        }
      });

      this.checkShareStartDate(_this, field, fieldData, moduleObj, index, isAuto);
      if ("1" === isAuto || !isAuto) {
        return;
      }

      moduleObj && index === benefitModule.length - 1 && (moduleObj.MODULE_ADD = "1");
    } catch (e) {
      consoleLog("判定受益人方式选择报错：" + e);
    } finally {
      this.handlerClassBeneficiaryIdType(_this);
    }
  },

  checkShareStartDate: function checkShareStartDate(_this, field, fieldData, moduleObj, index, isAuto) {
    if ("QS420" === _this.$store.state.busicode || "QS421" === _this.$store.state.busicode && _.includes(["BENEFICIARY_MODULE_1"], moduleObj.MODULE_ID)) {
      fieldData["SHARE_RATION_START_DATE"].FIELD_CONTROL = "0";
      fieldData["SHARE_RATION_START_DATE"].FIELD_REQUIRED = "1";
      if (_.includes(["g", "h"], field.DEFAULT_VALUE)) {
        fieldData["SHARE_RATION_START_DATE"].FIELD_REQUIRED = "1";
      } else if (_.includes(["i", "m", "k", "n"], field.DEFAULT_VALUE)) {
        fieldData["SHARE_RATION_START_DATE"].FIELD_REQUIRED = "0";
      } else if (_.includes(["j"], field.DEFAULT_VALUE)) {
        _this.$nextTick(function () {
          fieldData["SHARE_RATION_START_DATE"].DEFAULT_VALUE = "";
          fieldData["SHARE_RATION_START_DATE"].FIELD_REQUIRED = "0";
          fieldData["SHARE_RATION_START_DATE"].FIELD_CONTROL = "2";
        });
      }
    }
    if ("n" === field.DEFAULT_VALUE) {
      fieldData["SHARE_RATION_START_DATE"].FIELD_REQUIRED = "0";
    }
  },

  checkBeneficiaryControlMethod: function checkBeneficiaryControlMethod(_this, field, fieldData, moduleObj, index, isAuto) {
    if ("i" === fieldData["BENEFICIARY_TYPE"].DEFAULT_VALUE) {
      if (["3"].includes(field.DEFAULT_VALUE)) {
        fieldData["ACT_OTHER_FORMS"].FIELD_REQUIRED = "1";
        fieldData["ACT_OTHER_FORMS"].FIELD_CONTROL = "0";
      } else {
        fieldData["ACT_OTHER_FORMS"].FIELD_REQUIRED = "0";
        fieldData["ACT_OTHER_FORMS"].FIELD_CONTROL = "1";
        fieldData["ACT_OTHER_FORMS"].DEFAULT_VALUE = "";
      }
    }
  },

  checkUploadPublicPhoto: function checkUploadPublicPhoto(_this, field, fieldData, moduleObj, index, isAuto) {
    if (this.isLFieldDict(fieldData)) {
      return;
    }

    var flag = "1" === field.DEFAULT_VALUE;
    _.each(["BENEFICIARY_ID_TYPE", "BENEFICIARY_ID", "BENEFICIARY_EXP_DATE"], function (v) {
      fieldData[v].FIELD_REQUIRED = flag ? "0" : "1";
      fieldData[v].FIELD_CONTROL = "0";
      fieldData[v].correct = flag;
      setTimeout(function () {
        var errorEl = "#" + v + " .el-form-item__error";
        var errorDom = _this.$el.querySelector(errorEl);
        errorDom && (errorDom.style.display = flag && errorDom ? "none" : "");
      }, 10);
    });

    if (flag) {
      moduleObj.need_police = "0";
      _this.$nextTick(function () {
        _this.$set(moduleObj, "MODULE_CUSTOMIZE", "");
      });
    } else {}
  },

  hideBeneficiaryControlMethod: function hideBeneficiaryControlMethod(_this, moduleObj) {
    if (moduleObj.MODULE_ID === "BENEFICIARY_MODULE") {
      _.each(["ACT_CTRL_CPNY", "ACT_OTHER_FORMS"], function (v) {
        moduleObj.FIELDS[v].FIELD_REQUIRED = "0";
        moduleObj.FIELDS[v].FIELD_CONTROL = "1";
        moduleObj.FIELDS[v].DEFAULT_VALUE = "";
      });
    }
  },

  checkBeneficiaryTypeClick: function checkBeneficiaryTypeClick(_this, field, fieldData, moduleObj, index, isAuto) {
    if ("1" === isAuto) {
      return;
    }

    if ("l" === field.DEFAULT_VALUE) {
      _this.exsTip({
        title: "豁免识别客户",
        dialogFormVisible: true
      });
    } else if ("m" === field.DEFAULT_VALUE) {
        _this.exsTip({
          title: "简化识别客户",
          dialogFormVisible: false
        });
      }
  },

  hideFieldInModule: function hideFieldInModule(_this, moduleId, moduleObj, isChecked) {
    var fieldData = moduleObj.FIELDS;
    _Object$keys(fieldData).forEach(function (key) {
      if (key !== "CREDIT_BENEFICIARY_TYPE") {
        setTimeout(function () {
          fieldData[key].FIELD_CONTROL = "1";
          fieldData[key].DEFAULT_VALUE = "";
          fieldData[key].correct = true;
        }, 1);
      }
    });

    moduleObj && (moduleObj.MODULE_ADD = "0");

    moduleObj && (moduleObj.MODULE_READ = "0");
  },

  hideFieldInModuleHis: function hideFieldInModuleHis(_this, moduleId, module, historyBeneficiaryArr, seq) {
    var that = this;
    var historyItem = _.find(historyBeneficiaryArr, function (item) {
      return item.MODULE_NUMBER === module.MODULE_NUMBER;
    });
    if (_.isEmpty(historyItem)) {
      historyItem = historyBeneficiaryArr[seq];
    }
    if (!historyItem) {
      module.sameChecked = false;
      module.withoutChecked = false;
    }
    if (!_.isEmpty(historyItem) && historyItem.withoutChecked) {
      module.withoutChecked = historyItem.withoutChecked || false;
      setTimeout(function () {
        that.hideFieldInModule(_this, module.MODULE_ID, module, module.withoutChecked);
      }, 100);
    }
    if (!_.isEmpty(historyItem) && historyItem.sameChecked) {
      module.sameChecked = historyItem.sameChecked;
    }
  },

  showFieldInModule: function showFieldInModule(_this, moduleId, moduleObj, isChecked) {
    var fieldData = moduleObj.FIELDS;
    _Object$keys(fieldData).forEach(function (key) {
      if (key !== "CREDIT_BENEFICIARY_TYPE" && key !== "IS_SAME_LEGAL_REP") {
        fieldData[key].FIELD_CONTROL = "0";
      }
    });

    moduleObj && (moduleObj.MODULE_ADD = "1");
  },

  isModuleNeedTip: function isModuleNeedTip(_this, moduleId, moduleObj) {
    var fieldData = moduleObj.FIELDS;
    var isNeedTip = false;
    for (var key in fieldData) {
      if (fieldData.hasOwnProperty(key) && key !== "CREDIT_BENEFICIARY_TYPE") {
        if (fieldData[key].DEFAULT_VALUE && fieldData[key].FIELD_CONTROL !== "1") {
          isNeedTip = true;
          break;
        }
      }
    }
    return isNeedTip;
  },

  checkWithoutChange: function checkWithoutChange(_this, moduleId, moduleObj, isChecked, moduleArr, el) {
    var _this3 = this;

    var that = this;
    return new _Promise(function (res) {
      if (moduleArr.length > 1 || _this3.isModuleNeedTip(_this, moduleId, moduleObj)) {
        _this.alert({
          messageText: "是否确认勾选“无（若无，可不申报）”？确认后将清空当前已录入的全部受益所有人信息。",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          confirmedAction: function confirmedAction() {
            res(true);
          },
          canceledAction: function canceledAction() {
            res(false);
          }
        });
      } else {
        res(true);
      }
    }).then(function (flag) {
      if (!flag) {
        return false;
      }
      return new _Promise(function (res) {
        if (isChecked) {
          if (moduleArr.length > 1) {
            moduleArr.splice(1);
          }
          that.hideFieldInModule(_this, moduleId, moduleObj, isChecked);
          res(true);
        } else {
          that.showFieldInModule(_this, moduleId, moduleObj, isChecked);
          that.checkBeneficiaryType(_this, moduleObj.FIELDS.BENEFICIARY_TYPE, moduleObj.FIELDS, "", 0, "0", moduleObj);
          res(false);
        }
      });
    });
  },

  checkSameChange: function checkSameChange(_this, moduleId, moduleObj, isChecked, moduleArr, el) {
    var beneficiary0Arr = _.get(_this, "" + BENEFICIARY0);
    var beneficiary2Arr = _.get(_this, "" + BENEFICIARY2);
    var exceptFields = "CREDIT_BENEFICIARY_TYPE";
    return new _Promise(function (resolve0) {
      if (moduleObj.withoutChecked) {
        _this.alert({
          messageText: "当前已勾选“无（若无，可不申报）”，不可勾选“同‘信托产品委托人’”，请重新选择勾选方式。",
          confirmButtonText: "关闭",
          confirmedAction: function confirmedAction() {
            resolve0(false);
          }
        });
      } else {
        resolve0(true);
      }
    }).then(function (flag) {
      if (!flag) {
        return false;
      }
      return new _Promise(function (resolve1) {
        if (beneficiary0Arr.length === 1) {
          var beneficiary0Obj = beneficiary0Arr[0];

          if (beneficiary0Obj.withoutChecked) {
            _this.alert({
              messageText: "信托产品-委托人无信息，不用勾选：同‘信托产品委托人‘",
              confirmButtonText: "关闭",
              confirmedAction: function confirmedAction() {
                resolve1(false);
              }
            });
          } else {
            resolve1(true);
          }
        } else {
          resolve1(true);
        }
      });
    }).then(function (flag) {
      if (!flag) {
        return false;
      }
      return new _Promise(function (resolve) {
        if (isChecked) {
          _this.alert({
            messageText: "是否将信托产品委托人信息全部复制到该栏目，复制后信息将会被覆盖。",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            confirmedAction: function confirmedAction() {
              moduleObj.sameChecked = true;
              resolve([true, beneficiary0Arr, beneficiary2Arr, exceptFields, function (that) {}]);
            },
            canceledAction: function canceledAction() {
              moduleObj.sameChecked = false;
              resolve(false);
            }
          });
        } else {
          moduleObj.sameChecked = false;
          resolve(false);
        }
      });
    });
  },

  setBeneficiaryType: function setBeneficiaryType(flag, module) {
    if (flag && module.FIELDS.BENEFICIARY_TYPE.DEFAULT_VALUE !== "") {
      module.FIELDS.BENEFICIARY_TYPE.DEFAULT_VALUE = "";
    }
  },

  checkModuleAdd: function checkModuleAdd(beneficiaryArr, module, seq) {
    if (beneficiaryArr.length > 1) {
      module.MODULE_ADD = seq === beneficiaryArr.length - 1 ? "1" : "0";
    } else {
      module.MODULE_ADD = "1";
    }
  },

  changeProCls: function changeProCls(_this, proCls, flag) {
    var that = this;
    var benefitListObjHis = that.getFilterBenefitListObj(_this.historyData && _this.historyData.BIZ_DATA && _this.historyData.BIZ_DATA.BENEFICIARY_INFO_LIST);

    if (that.isTrustProducts(proCls)) {
      _this.oppBusiData.isTrustProducts = "1";

      _.each(_.get(_this, "" + BENEFICIARY), function (module) {
        module.MODULE_CONTROL = "0";
        that.setBeneficiaryType(flag, module);
      });

      var beneficiary1Arr = _.get(_this, "" + BENEFICIARY1);
      _.each(beneficiary1Arr, function (module, seq) {
        module.MODULE_CONTROL = "1";
        that.checkModuleAdd(beneficiary1Arr, module, seq);
        that.handlerClassBeneficiaryIdType(_this, proCls, module);
        that.getFilterFieldDictProductsField(_this, ONE, module);
        that.setBeneficiaryType(flag, module);
      });

      var beneficiary0Arr = _.get(_this, "" + BENEFICIARY0);
      var historyBeneficiary0Arr = benefitListObjHis.BENEFICIARY_MODULE_0;
      _this.oppBusiData.isTrustProductsHis === "0" && (historyBeneficiary0Arr = []);
      _.each(beneficiary0Arr, function (module, seq) {
        module.MODULE_CONTROL = "1";
        seq === 0 && (module.MODULE_WITHOUT = "1");
        that.checkModuleAdd(beneficiary0Arr, module, seq);
        that.handlerClassBeneficiaryIdType(_this, proCls, module);
        that.getFilterFieldDictProductsField(_this, ZERO, module);
        that.setBeneficiaryType(flag, module);
        that.hideFieldInModuleHis(_this, module.MODULE_ID, module, historyBeneficiary0Arr, seq);
      });

      var beneficiary2Arr = _.get(_this, "" + BENEFICIARY2);
      var historyBeneficiary2Arr = benefitListObjHis.BENEFICIARY_MODULE_2;
      _this.oppBusiData.isTrustProductsHis === "0" && (historyBeneficiary2Arr = []);
      _.each(beneficiary2Arr, function (module, seq) {
        module.MODULE_CONTROL = "1";
        seq === 0 && (module.MODULE_SAME = "1");
        seq === 0 && (module.MODULE_WITHOUT = "1");
        that.checkModuleAdd(historyBeneficiary2Arr, module, seq);
        that.handlerClassBeneficiaryIdType(_this, proCls, module);
        that.getFilterFieldDictProductsField(_this, TWO, module);
        that.setBeneficiaryType(flag, module);
        that.hideFieldInModuleHis(_this, module.MODULE_ID, module, historyBeneficiary2Arr, seq);
      });

      var beneficiary3Arr = _.get(_this, "" + BENEFICIARY3);
      var historyBeneficiary3Arr = benefitListObjHis.BENEFICIARY_MODULE_3;
      _this.oppBusiData.isTrustProductsHis === "0" && (historyBeneficiary3Arr = []);
      _.each(beneficiary3Arr, function (module, seq) {
        module.MODULE_CONTROL = "1";
        seq === 0 && (module.MODULE_WITHOUT = "1");
        that.checkModuleAdd(historyBeneficiary3Arr, module, seq);
        that.handlerClassBeneficiaryIdType(_this, proCls, module);
        that.getFilterFieldDictProductsField(_this, THREE, module);
        that.setBeneficiaryType(flag, module);
        that.hideFieldInModuleHis(_this, module.MODULE_ID, module, historyBeneficiary3Arr, seq);
      });

      var beneficiary4Arr = _.get(_this, "" + BENEFICIARY4);
      var historyBeneficiary4Arr = benefitListObjHis.BENEFICIARY_MODULE_4;
      _this.oppBusiData.isTrustProductsHis === "0" && (historyBeneficiary4Arr = []);
      _.each(beneficiary4Arr, function (module, seq) {
        module.MODULE_CONTROL = "1";
        seq === 0 && (module.MODULE_WITHOUT = "1");
        that.checkModuleAdd(beneficiary4Arr, module, seq);
        that.handlerClassBeneficiaryIdType(_this, proCls, module);
        that.getFilterFieldDictProductsField(_this, FOUR, module);
        that.setBeneficiaryType(flag, module);
        that.hideFieldInModuleHis(_this, module.MODULE_ID, module, historyBeneficiary4Arr, seq);
      });
    } else {
        _this.oppBusiData.isTrustProducts = "0";
        _.each(_.get(_this, "" + BENEFICIARY1), function (module) {
          module.MODULE_CONTROL = "0";
        });
        _.each(_.get(_this, "" + BENEFICIARY0), function (module) {
          module.MODULE_CONTROL = "0";
        });
        _.each(_.get(_this, "" + BENEFICIARY2), function (module) {
          module.MODULE_CONTROL = "0";
        });
        _.each(_.get(_this, "" + BENEFICIARY3), function (module) {
          module.MODULE_CONTROL = "0";
        });
        _.each(_.get(_this, "" + BENEFICIARY4), function (module) {
          module.MODULE_CONTROL = "0";
        });
        var beneficiaryModule = benefitListObjHis.BENEFICIARY_MODULE;
        _.each(_.get(_this, "" + BENEFICIARY), function (module, index) {
          module.MODULE_CONTROL = "1";
          var beneficiaryType = module.FIELDS.BENEFICIARY_TYPE;
          beneficiaryType.FIELD_DICT_FILTER = that.getFilterFieldDictNoProducts(_this, proCls, module);
          if (!beneficiaryType.DEFAULT_VALUE && beneficiaryModule.length) {
            beneficiaryType.DEFAULT_VALUE = beneficiaryModule[index]["BENEFICIARY_TYPE"];
          }
          if (!beneficiaryType.FIELD_DICT_FILTER.includes(beneficiaryType.DEFAULT_VALUE)) {
            _this.$nextTick(function () {
              setTimeout(function () {
                that.handlerClassBeneficiaryIdType(_this, proCls, module);
              }, 1);
              beneficiaryType.DEFAULT_VALUE = "";
              beneficiaryType.correct = false;
            });
          }
          module.FIELDS.IS_SAME_LEGAL_REP && (module.FIELDS.IS_SAME_LEGAL_REP.FIELD_CONTROL = "0");
          if (index > 0) {
            module.FIELDS.IS_SAME_LEGAL_REP && (module.FIELDS.IS_SAME_LEGAL_REP.FIELD_CONTROL = "1");
          }
          that.setBeneficiaryType(flag, module);
        });
      }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/business/businessTools/bizBenefitMethod.js
// module id = 205
// module chunks = 2